module.exports = require('./dist/module-helpers');



//////////////////
// WEBPACK FOOTER
// ./~/angular-ecmascript/module-helpers.js
// module id = 733
// module chunks = 0